(function accordionTabs($, Drupal, once) {
  Drupal.behaviors.rutherfordAccordionTabs = {
    attach(context) {
      $(
        once(
          'rutherford-accordion-tabs',
          '.tabs[data-responsive-accordion-tabs]',
          context,
        ),
      ).each(function eachTabs() {
        const _tabs = new Foundation.ResponsiveAccordionTabs($(this), {
          allowAllClosed: true,
        });
        const tabsControlsContainer = this.previousElementSibling;
        const tabsControls = tabsControlsContainer.querySelectorAll(
          '[data-horizontal-slider-control]',
        );
        const currentTabs = [...this.querySelectorAll('.tabs-title')];
        let activeIndex = 0;

        tabsControls.forEach(tabControl => {
          tabControl.addEventListener('click', e => {
            var leftPos = $(this).scrollLeft();
            if (e.target.dataset.horizontalSliderControl === 'next') {
              $(this).animate({ scrollLeft: leftPos + 200 }, 250);
            } else if (e.target.dataset.horizontalSliderControl === 'prev') {
              $(this).animate({ scrollLeft: leftPos - 200 }, 250);
            }
          });
        });

        const resizeObserver = new ResizeObserver(entries => {
          for (const entry of entries) {
            if (entry.contentRect) {
              // Check if the tabs overflow to allow horizontal scrolling and
              // adjust the bottom border colour accordingly.
              if (this.scrollWidth > this.parentElement.clientWidth) {
                this.classList.add('tabs-overflow');
                tabsControls[0].parentElement.classList.add('md:u-flex');

                // Set a height for the tabs so we can hide the scrollbar whilst
                // retaining functionality.
                document.documentElement.style.setProperty(
                  '--responsive-tabs--tabs-height',
                  `${this.querySelector('.tab_link').clientHeight}px`,
                );

                // Allow scroll horizontally when using a mouse with a wheel.
                this.addEventListener(
                  'wheel',
                  e => (this.scrollLeft += e.deltaY),
                );
              } else {
                this.classList.remove('tabs-overflow');
                tabsControls[0].parentElement.classList.remove('md:u-flex');
              }

              let intersectionObsCallback = entries => {
                const entry = entries.find(e => e.isIntersecting);

                if (entry) {
                  const index = currentTabs.findIndex(e => e === entry.target);
                  activeIndex = index;

                  const prevControl = tabsControls[0];
                  const nextControl = tabsControls[1];

                  prevControl.setAttribute('aria-disabled', !(activeIndex > 0));
                  nextControl.setAttribute(
                    'aria-disabled',
                    activeIndex === currentTabs.length - 1,
                  );
                }
              };

              const intersectionObs = new IntersectionObserver(
                intersectionObsCallback,
                {
                  root: this,
                  rootMargin: '0px',
                  threshold: 0.75,
                },
              );

              currentTabs.forEach(el => {
                intersectionObs.observe(el);
              });
            }
          }
        });

        window.addEventListener('resize', () => {
          window.matchMedia('(min-width:768px)').matches
            ? resizeObserver.observe(this)
            : resizeObserver.unobserve(this);
        });
      });
    },
  };
})(jQuery, Drupal, once);
